import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface Country {
  Code: string;
  EnglishName: string;
  FinnishName: string;
}

interface CountryApiResponse {
  id: string;
  en: string;
  fi: string;
}

interface CountriesState {
  countries: Country[];
  isLoading: boolean;
  loaded: boolean;
  noPersistance?: boolean;
  isError?: boolean;
}

export const getInitialState = (): CountriesState => ({
  countries: [],
  isLoading: false,
  loaded: false,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_COUNTRIES}_REQUEST`]: (): Partial<CountriesState> => ({
    countries: [],
    isLoading: true,
    loaded: false
  }),

  [`${ApiConstants.LOAD_COUNTRIES}_SUCCESS`]: (
    state: CountriesState,
    { countries }: { countries: CountryApiResponse[] }
  ): Partial<CountriesState> => {
    const mappedCountries = countries.map(item => ({
      Code: item.id,
      EnglishName: item.en,
      FinnishName: item.fi
    }));
    return {
      countries: mappedCountries,
      isLoading: false,
      loaded: true
    };
  },

  [`${ApiConstants.LOAD_COUNTRIES}_FAILURE`]: (
    state: CountriesState
  ): Partial<CountriesState> =>
    !state.isError
      ? {
          countries: [],
          isLoading: false,
          loaded: true,
          isError: true
        }
      : state
});
